function readDurationOverride(value: string | undefined, fallback: number): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

export const IDLE_TIMEOUT_MS = readDurationOverride(
  import.meta.env.VITE_SESSION_IDLE_TIMEOUT_MS,
  15 * 60 * 1000,
)

export const SESSION_WARNING_MS = readDurationOverride(
  import.meta.env.VITE_SESSION_WARNING_TIMEOUT_MS,
  60 * 1000,
)

export const ABSOLUTE_TIMEOUT_MS = readDurationOverride(
  import.meta.env.VITE_SESSION_ABSOLUTE_TIMEOUT_MS,
  8 * 60 * 60 * 1000,
)
export const SESSION_EXPIRED_STORAGE_KEY = 'ceta:session-expired'

export function getSessionStartedAtKey(userId: string): string {
  return `ceta:session-started-at:${userId}`
}

export function getLastActivityAtKey(userId: string): string {
  return `ceta:last-activity-at:${userId}`
}

export function readStoredTimestamp(storage: Storage, key: string): number | null {
  const rawValue = storage.getItem(key)
  if (!rawValue) return null

  const parsed = Number(rawValue)
  return Number.isFinite(parsed) ? parsed : null
}

const SESSION_STARTED_AT_PREFIX = 'ceta:session-started-at:'
const LAST_ACTIVITY_AT_PREFIX = 'ceta:last-activity-at:'

export function purgeStaleSessionKeys(storage: Storage, now: number = Date.now()): void {
  const keysToRemove: string[] = []
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i)
    if (!key) continue

    if (key.startsWith(SESSION_STARTED_AT_PREFIX)) {
      const value = readStoredTimestamp(storage, key)
      if (value == null || now - value >= ABSOLUTE_TIMEOUT_MS) {
        keysToRemove.push(key)
      }
    } else if (key.startsWith(LAST_ACTIVITY_AT_PREFIX)) {
      const value = readStoredTimestamp(storage, key)
      if (value == null || now - value >= IDLE_TIMEOUT_MS) {
        keysToRemove.push(key)
      }
    }
  }

  keysToRemove.forEach((key) => storage.removeItem(key))
}
